export default __webpack_public_path__ + "static/realWorldImg2-92f64bb72cd8e3ccbe988a66605bfd9e.png";